import React from 'react';
import styled from 'styled-components';
import { LinkContained } from './form/LinkContained';

interface Props {
    id: string;
    heading: string;
    subheading: string;
    descriptionHTML: string;
    price: number;
    url: string;
    label: string;
    color: string;
}

const Container = styled.div<{ $color: string; }>`
    display: grid;
    grid-template-rows: auto 1fr auto;
    border: 1px solid ${({ $color }) => $color || 'transparent'};
`;

const Header = styled.header<{ $color: string; }>`
    padding: 8px;
    color: #fff;
	text-align: center;
    background-color: ${({ $color }) => $color};
`;

const Heading = styled.h3`
	margin: 0;
    text-transform: uppercase;
`;

const Subheading = styled.h4`
	margin: 0;
`;

const Price = styled.div<{ $color: string; }>`
    margin: 8px 0 24px;
    color: ${({ $color }) => $color};
	${({ theme }) => theme.getTypography('h4')};
    text-align: center;
`;

const Description = styled.div`
	box-sizing: border-box;
	margin: var(--body-margin);
	padding: 24px;
    ${({ theme }) => theme.typography.richtext};
    ${({ theme }) => theme.ticks};
`;

const PayButton = styled(LinkContained)`
    justify-self: center;
	display: block;
	min-width: 64px;
    margin-bottom: 16px;
`;

export const Payment = ({ heading, subheading, descriptionHTML, price, label, url, color }: Props) =>
    <Container $color={color}>
        <Header $color={color}>
            {heading &&
                <Heading>{heading}</Heading>
            }
            {subheading &&
                <Subheading>{subheading}</Subheading>
            }
        </Header>
        {descriptionHTML &&
            <Description dangerouslySetInnerHTML={{ __html: descriptionHTML }} />
        }
        {price &&
            <Price $color={color}>{price} zł</Price>
        }
        {label && url &&
            <PayButton href={url} target="_blank">{label}</PayButton>
        }
    </Container>